export default "__VITE_ASSET__5c76a7ef__"